import { render, staticRenderFns } from "./courseReview.vue?vue&type=template&id=c0341fd2&"
import script from "./courseReview.vue?vue&type=script&lang=js&"
export * from "./courseReview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports